import { decode } from 'jsonwebtoken';

export const getUserIdFromToken = (token: string): string =>
  (decode(token) as any)?.userId;
